import formatCaseData from './formatCaseData';
import formatClientData from './formatClientData';
import formatReferralData from './formatReferralData';
import { EXTERNAL_ID_LABEL, MEDICAID_ID_LABEL, MODELS } from '../constants';

const { contact, referral, servicecase } = MODELS;

function getColumnHeaders(
  model,
  clientIdStandardizationEnabled = false,
  medicaidFilteringEnabled = false,
) {
  switch (model) {
    case contact: {
      const headers = [
        { label: 'Client Name', value: 'full_name' },
        { label: 'Phone', value: 'phone' },
        { label: 'DOB', value: 'dob' },
        { label: 'Location', value: 'location' },
        { label: 'Email', value: 'email' },
      ];

      if (clientIdStandardizationEnabled || medicaidFilteringEnabled) {
        const label = medicaidFilteringEnabled ? MEDICAID_ID_LABEL : EXTERNAL_ID_LABEL;
        const value = 'external_id';
        headers.splice(1, 0, { label, value });
      }

      return {
        getRowValues: formatClientData,
        headers,
      };
    }

    case referral: {
      return {
        getRowValues: formatReferralData,
        headers: [
          { label: 'Recipient', value: 'recipient' },
          { label: 'Client Name', value: 'full_name' },
          { label: 'Sent By', value: 'created_by' },
          { label: 'Service Type', value: 'service_type' },
          { label: 'Status', value: 'status' },
          { label: 'Last Updated', value: 'updated_at' },
        ],
      };
    }

    case servicecase: {
      return {
        getRowValues: formatCaseData,
        headers: [
          { label: 'Client Name', value: 'full_name' },
          { label: 'Program', value: 'program_name' },
          { label: 'Service Type', value: 'service_type' },
          { label: 'Status', value: 'status' },
          { label: 'Primary Worker', value: 'primary_worker' },
          { label: 'Last Updated', value: 'updated_at' },
        ],
      };
    }

    default:
      return {};
  }
}

export default getColumnHeaders;
